import { render, staticRenderFns } from "./SuppliersLoginForm.vue?vue&type=template&id=d66db820&scoped=true&"
import script from "./SuppliersLoginForm.vue?vue&type=script&lang=ts&"
export * from "./SuppliersLoginForm.vue?vue&type=script&lang=ts&"
import style0 from "./SuppliersLoginForm.vue?vue&type=style&index=0&id=d66db820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66db820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VForm,VIcon,VRow,VTextField})
